<template>
  <div>
    {{ label }}
    <v-checkbox
      v-for="({ choiceLabel, choiceValue }, index) in choices"
      :key="index"
      v-model="question.value"
      :label="choiceLabel"
      :disabled="disabled"
      :value="choiceValue"
      :rules="[required ? requiredRule : true]"
      :hide-details="index < choices.length - 1"
    />
  </div>
</template>

<script>
import QuestionMixin from "./QuestionMixin";

export default {
  name: "CheckboxQuestion",
  methods: {
    evaluateAllExpressions() {
      this.question.expressions.forEach(expression => {
        let satisfied = false;
        switch (expression.condition) {
          case "isBlank":
            satisfied = this.question.value.length === 0;
            break;
          case "isNotBlank":
            satisfied = this.question.value.length > 0;
            break;
          case "is":
            satisfied =
              this.question.value.length === 1 &&
              this.question.value[0] === expression.value.value;
            break;
          case "contains":
            satisfied = this.question.value.some(
              val => val === expression.value.value
            );
            break;
          case "isNot": //Not sure what isNot even means, so implementing the same as doesNotContain
          case "doesNotContain":
            satisfied = !this.question.value.some(
              val => val === expression.value.value
            );
            break;
          default:
            break;
        }
        this.$set(expression, "satisfied", satisfied);
      });
    }
  },
  mixins: [QuestionMixin],
  data() {
    return {
      requiredRule: val => {
        return (
          !Array.isArray(val) || val.length > 0 || "One option is required"
        );
      }
    };
  },
  computed: {
    choices() {
      if (!this.question.choices || !this.question.choices.length) return [];

      return this.question.choices.map(choice => {
        if (typeof choice === "string")
          return { choiceLabel: choice, choiceValue: choice };
        else if (typeof choice === "object")
          return { choiceLabel: choice.text, choiceValue: choice.value };
        else throw new Error("Unknown choice type", choice);
      });
    }
  }
};
</script>

<style scoped></style>
